// Editorial palette lifted from the approved Stitch mockups ("Sanctuary Modern").
// Used by the custom pages and the About Us page; kept separate from the site's
// MUI theme so it doesn't touch any other screen.
export const editorial = {
  canvas: "#F9F8F5",
  paper: "#FFFFFF",
  divider: "#E6E2DA",
  sectionAlt: "#F4F1EA",
  primary: "#0C4A4A",
  primaryContainer: "#003232",
  primaryFixed: "#B5EDEC",
  secondary: "#5A7865",
  secondaryContainer: "#C7E8D1",
  surfaceContainerLow: "#F3F1EC",
  surfaceContainerHigh: "#E4E0D7",
  outlineVariant: "#BFC8C8",
  text: "#1E2322",
  textVariant: "#404848",
  headlineFont: '"Source Serif 4", serif',
  bodyFont: '"Inter", sans-serif',
  cardShadow: "0px 2px 8px rgba(30, 35, 34, 0.04)",
};

// The faint repeating texture behind the mockup's header card, reused on every
// card so they read as one surface treatment. Sage (#476553) at 2.5%
// opacity -- applied on the <g> as both fill-opacity and stroke-opacity, since
// the circle below is stroked (not filled) and fill-opacity alone leaves a
// stroke at full 100% opacity, which is what made this look busy before.
export const cardTexture = `url("data:image/svg+xml,%3Csvg width='96' height='96' viewBox='0 0 96 96' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23476553' fill-opacity='0.025' stroke-opacity='0.025' fill-rule='evenodd'%3E%3Ccircle cx='48' cy='48' r='44' stroke='%23476553' stroke-width='2' fill='none'/%3E%3Cpath d='M36 28a16 16 0 0 0-16 16v8a16 16 0 0 0 32 0v-4h-8v4a8 8 0 0 1-16 0v-8a8 8 0 0 1 16 0v2h8v-2a16 16 0 0 0-16-16zm24 0a16 16 0 0 0-16 16v8a16 16 0 0 0 32 0v-10h-16v6h8v4a8 8 0 0 1-16 0v-8a8 8 0 0 1 16 0v2h8v-2a16 16 0 0 0-16-16z'/%3E%3C/g%3E%3C/svg%3E")`;
